module.exports = __webpack_public_path__ + "img/assia-popup.eaa15388.png";